/* eslint-disable */

<template>
  <div class="page-wraper">
    <div class="content-body">
      <div class="container vh-100">
        <div class="welcome-area">
          <div class="welcome-logo">
            <img src="../../assets/Waiter_3.png">
            <div class="get-started">
              <h1 class="dz-title"></h1>
            </div>
          </div>
          <div class="">
            <div class="started">
              <p class="text-gray">{{ $t('choose_procees') }}</p>
            </div>
            <router-link style="width: 100%;" :to="{name: 'home-page'}" class="mb-3 btn btn-primary text-white">
                  {{$t('assisted_road')}}
            </router-link>
            <router-link style="width: 100%;" :to="{name: 'home-page'}" class="btn bg-transparent text-primary border-primary">
                 {{ $t('simple_road') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>
.welcome-area .welcome-logo img {
    width: 250px;
  }
  form{
    padding-top: 20px;
  }
</style>